<template>
  <v-btn
    color="primary"
    size="small"
    @click="dialog = true"
  >
    <div
      v-if="buttonText"
      class="me-2"
    >
      {{ buttonText }}
    </div>
    <v-icon icon="fas fa-crosshairs" />
    <v-dialog
      v-model="dialog"
      max-width="800px"
    >
      <global-card :title="title">
        <v-text-field
          v-model="search"
          :label="t('global.search')"
          clearable
          @keyup.enter="searchLocation"
        >
          <template #append-inner>
            <v-btn
              color="primary"
              :text="t('global.search')"
              size="small"
              @click="searchLocation"
            />
          </template>
        </v-text-field>

        <smpw-map
          :center="mapCenter"
        >
          <smpw-map-marker
            :position="position"
            :icon="icon"
            :color="color"
            :read-only="false"
            @update:position="onDragEnd"
          />
        </smpw-map>

        <template #actions>
          <v-btn
            color="dark-grey"
            :text="t('actions.close')"
            size="small"
            @click="close"
          />
          <v-btn
            color="primary"
            :text="t('location.update')"
            size="small"
            @click="sendLocationUpdate"
          />
        </template>
      </global-card>
    </v-dialog>
  </v-btn>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import SmpwMap from '@/components/globals/SmpwMap.vue';
import SmpwMapMarker from '@/components/globals/SmpwMapMarker.vue';
import { useMapStore } from '@/stores/maps';

withDefaults(defineProps<{
  title?: string;
  buttonText?: string;
  icon: string;
  color?: string;
}>(), {
  title: () => useI18n().t('location.search'),
});

const emit = defineEmits(['update:location']);

const { t } = useI18n();

const { cityCentre } = storeToRefs(useMapStore());
const dialog = ref(false);

const mapCenter = ref<google.maps.LatLngLiteral>({ ...cityCentre.value });

const search = ref('');

const position = ref<google.maps.LatLngLiteral>({ ...cityCentre.value });

function onDragEnd(e: google.maps.MapMouseEvent): void {
  if (!e.latLng) {
    return;
  }
  position.value.lat = e.latLng.lat();
  position.value.lng = e.latLng.lng();
}

function searchLocation(): void {
  const geocoder = new google.maps.Geocoder();
  geocoder.geocode({ address: search.value }, (results, status) => {
    if (status === 'OK' && results?.length) {
      position.value = {
        lat: results[0].geometry.location.lat(),
        lng: results[0].geometry.location.lng(),
      };
      mapCenter.value = { ...position.value };
    }
  });
}

function close() {
  dialog.value = false;
}

function sendLocationUpdate() {
  emit('update:location', position.value);
  close();
}
</script>
